<template>
  <v-dialog v-model="adminUserDialog" width="1200">
    <v-card style="background-color:#323232;">
      <!-- <pre>{{item}}</pre> -->
      <v-toolbar flat style="background-color:#eee">
        <v-spacer></v-spacer>
        <!--Country name-->
         <p class="pr-5 text--primary display-1 pt-5" >
          {{item.FullName}}
        </p>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!--Statistic Data-->
        <v-row class="ma-0 pa-0 pt-3">
          <v-col class="ma-0 pa-0">
            <v-card class="pa-2" style="background-color: #eee" outlined>
              <p class="title ma-0 pa-0 pb-2 text-center" style="color: white; font-size: 1.2em; font-weight: 700; letter-spacing: .2em; text-shadow: 2px 2px 10px #000, 2px 2px 20px #000, -2px -2px 20px #000, 2px -2px 20px #000, -2px 2px 20px #000;">Personalia</p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>Full Name:</span>
                <span class="font-weight-bold pl-1">{{item.FullName}}</span>
              </p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>First Name:</span>
                <span class="font-weight-bold pl-1">{{item.FirstName}}</span>
              </p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>Last Name:</span>
                <span class="font-weight-bold pl-1">{{item.LastName}}</span>
              </p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>Gender:</span>
                <span class="font-weight-bold pl-1" v-if="item.Sex == 'M'">Male</span>
                <span class="font-weight-bold pl-1" v-else-if="item.Sex == 'F'">Female</span>
                <span class="font-weight-bold pl-1" v-else>Gender Unknown</span>
              </p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>Country:</span>
                <span class="font-weight-bold pl-1">{{item.Country}}</span>
              </p>
            </v-card>
          </v-col>
          <v-col class="ma-0 pa-0 pl-2 pr-2">
            <v-card class="pa-2" style="background-color: #eee" outlined>
              <p class="title ma-0 pa-0 pb-2 text-center" style="color: white; font-size: 1.2em; font-weight: 700; letter-spacing: .2em; text-shadow: 2px 2px 10px #000, 2px 2px 20px #000, -2px -2px 20px #000, 2px -2px 20px #000, -2px 2px 20px #000;">User Data</p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>Email:</span>
                <span class="font-weight-bold pl-1">{{item.Email}}</span>
              </p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>User id:</span>
                <span class="font-weight-bold pl-1">{{item.id}}</span>
              </p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>User status:</span>
                <span class="font-weight-bold pl-1">{{item.Status}}</span>
              </p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>User Created:</span>
                <span class="font-weight-bold pl-1">{{item.Created | moment('LL')}}</span>
              </p>
              <p class="subtitle-1 ma-0 pa-0">
                <span>User active for:</span>
                <span class="font-weight-bold pl-1">{{item.CreatedDays}}</span>
                <span class="pl-1">days</span>
              </p>
            </v-card>
          </v-col>
        </v-row>
       <!--Data table-->
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0 pt-4">
            <v-card class="pa-2" style="background-color: #eee" outlined>
              <p class="title ma-0 pa-0 pb-2 pt-3 text-center" style="color: white; font-size: 1.2em; font-weight: 700; letter-spacing: .2em; text-shadow: 2px 2px 10px #000, 2px 2px 20px #000, -2px -2px 20px #000, 2px -2px 20px #000, -2px 2px 20px #000;">User Articles</p>
              <v-row class="ma-0 pa-0">
                <v-col class="ma-0 pa-0 pt-4" md="12">
                  <v-data-table
                    :items="item.articles"
                    :headers="headers"
                    :search="search"
                    :expanded.sync="expanded"
                    item-key="id"
                    @click:row="expandRow"
                  >
                    <!--Searchbar-->
                    <template v-slot:top>
                      <v-text-field v-model="search" label="Search articles here" class="mx-4" clearable></v-text-field>
                    </template>
                    <!--Custom message if published-->
                    <template v-slot:item.Published="{ item }">
                      <span v-if="item.Published == 1" class="indigo--text font-weight-bold"> Yes</span>
                      <span v-else class="red--text font-weight-bold"> No</span>
                    </template>
                    <!--See if comments disabled or amount of comments-->
                    <template v-slot:item.Comments="{ item }">
                      <span v-if="item.Comments == 0" class="red--text font-weight-bold"> Disabled</span>
                      <span v-else class="font-weight-bold"> {{item.TotalComments}} </span>
                    </template>
                    <!--See when article was created with Moment-->
                    <template v-slot:item.Created="{ item }">
                      <span> {{ item.Created | moment('LL') }}</span>
                    </template>
                    <!--See when article was updated with Moment - check if updated? or same as created.-->
                    <template v-slot:item.Updated="{ item }">
                      <span> {{ item.Updated | moment('LL') }}</span>
                    </template>
                    <!--Expand Menu-->
                    <template v-slot:expanded-item="{ headers, item }" >
                      <td :colspan="headers.length" style="background-color: #eee">
                        <v-row class="ma-0 pa-0">
                          <v-col md="3" class="ma-0 pa-0 mt-3 pa-2">
                            <v-img
                              :src="`${item.s3url}`"
                              height="100%"
                              cover
                            />
                          </v-col>
                          <v-col class="ma-0 pa-0 mt-3 pa-2 subtitle-1" v-html="item.Content"></v-col>
                        </v-row>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data(){
    return{
      // Toggling the dialog based on boolean
      adminUserDialog:false,
      // The data from the parent
      item: {},
      // Only allowing single expand, not multiple
      singleExpand: true,
      // Adding search
      search: '',
      // Accept the expand, and put into temp array
      expanded: [],
      // Data table header
      headers:[
        { text: 'Title', value: 'Title', align: 'left' },
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Published?', value: 'Published', align: 'center' },
        { text: 'Comments?', value: 'Comments', align: 'center' },
        { text: 'Type', value: 'ArticleType', align: 'center' },
        { text: 'Views', value: 'TotalViews', align: 'center' },
        { text: 'Created', value: 'Created', align: 'center' },
        { text: 'Updated', value: 'Updated', align: 'center' }
      ]
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog(item) {
      this.item = item;
      this.adminUserDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.adminUserDialog = false;
    },
    // Open up the expand within the table
    expandRow (item) {
      this.expanded = item === this.expanded[0] ? [] : [item]
    },
  }
}
</script>